// import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const PREFIX = '_euOptionSlider';

const classes = {
  dot: `${PREFIX}-dot`,
  dots: `${PREFIX}-dots`,
};

const Labels = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  '& > *': {
    flex: 1,
  },
}));

const Chart = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: 50,
  [`& .${classes.dots}`]: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    marginRight: 50,
  },
  [`& .${classes.dot}`]: {
    flex: 1,
  },
}));

interface IMark {
  label: string;
  left: string;
  color: string;
  border?: boolean;
}

const Rails = styled('div')(() => ({
  position: 'absolute',
  width: '100%',
  height: 6,
  left: 0,
  top: '50%',
  marginTop: -3,
  backgroundColor: '#d6d6d6',
}));

const Dot = styled('div', {
  shouldForwardProp: (prop) => prop !== 'left' && prop !== 'color',
})<{ left: string; color: string }>(({ color, left }) => ({
  position: 'absolute',
  top: '50%',
  marginTop: -25,
  left: left,
  height: 50,
  width: 50,
  borderRadius: 25,
  backgroundColor: color,
  '&.border': {
    border: 'solid 1px black',
  },
}));

interface IProps {
  title: string;
  option: number;
}

export default function EuOptionSlider(props: IProps): JSX.Element {
  const { option, title } = props;

  const generateMarksSchema = () => {
    const gray = '#d6d6d6';
    return [
      {
        value: 0,
        label: 'one',
        left: '0%',
        color: option === 0 ? '#fd5657' : gray, // red
      },
      {
        value: 1,
        label: 'one',
        left: '33.33%',
        color: option === 1 ? '#e6b130' : gray, // amber
      },
      {
        value: 2,
        label: 'two',
        left: '66.66%',
        color: option === 2 ? '#ffffff' : gray, // white
        border: option === 2,
      },
      {
        value: 3,
        label: 'three',
        left: '100%',
        color: option === 3 ? '#24c8a6' : gray, // blue
      },
    ];
  };

  const renderDot = (mark: IMark, index: number) => {
    const { color, left, border } = mark;
    return <Dot key={index} color={color} left={left} className={border ? 'border' : ''} />;
  };

  return (
    <div>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Chart>
        <Rails />
        <div className={classes.dots}>{generateMarksSchema().map(renderDot)}</div>
      </Chart>
      <Labels>
        <Typography variant="body1" sx={{ textAlign: 'left' }}>
          Significant Harm Found
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'left' }}>
          Opportunity For Improvement
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'right' }}>
          No Significant Harm
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'right' }}>
          Positively Contributing
        </Typography>
      </Labels>
    </div>
  );
}
